<script lang="ts">
import tablePageInit from "../packages/datakode/nuxt-datakode-utils/utils/tablePageInit.vue"

export default {
    extends: tablePageInit,
    props: {
        customQuery: {
            type: Object,
            default: () => null,
        },
        moreCustomQueries: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        loadData() {
            if (this.hasPermissionOnTable) { // KEEP PERMISSION CHECK HERE FOR RELOADS
                const filterQuery = { ...this.$refs.filters?.getQuery() }
                const paginationQuery = this.$refs.pagination?.getQuery() || null
                const sort = this.$refs.table?.sort || null
                this.loading = true
                if (this.customQuery?.customQueryKey && this.customQuery?.queryId) {
                    filterQuery[this.customQuery.customQueryKey] = this.customQuery.queryId
                }
                if (this.moreCustomQueries.length > 0) {
                    this.moreCustomQueries.forEach(customQuery => filterQuery[customQuery.customQueryKey] = customQuery.queryValue)
                }
                this.$api.getListData({
                    url: this.requestName,
                    query: filterQuery,
                    translation: this.translationName,
                    pagination: paginationQuery,
                    sort,
                }).then((res) => {
                    this.data = res.data
                    this.meta = res.meta
                    this.filters = res.meta.allowed_filters
                    this.sortable = res.meta.allowed_sorts
                    this.exportable = res.meta.available_exports
                    this.lastPage = res.meta.last_page
                    this.total = res.meta.total
                    // this.sort = res.meta.request.sort

                    // RESET SELECTED DATA FROM TABLE IF EXIST
                    if (this.$refs.table) {
                        // this.$refs.table.resetSelectedData()
                    }

                    this.loading = false
                }).catch(() => {
                    throw createError({
                        statusCode: 404,
                        fatal: true,
                        statusMessage: "Page Not Found",
                    })
                })
                if (this.hasMap) {
                    if (this.previousFiltersQuery !== filterQuery) {
                        this.previousFiltersQuery = { ...filterQuery }
                        this.loadMapData()
                    }
                }
            }
            else {
                console.error(`Permission needed: ${permission}`)
            }
        },
    },
}
</script>
